module.exports = __webpack_public_path__ + "static/assets/d8a10614eda3d7d5e91559ff99e7ee58.svg";